import { FvLinkButton } from '@fv/client-components'
import { authUri } from '@fv/client-core'

import { ProfileForm } from './ProfileForm'

export const SettingsPage = () => {
  return (
    <main className="col-span-3 row-span-2">
      <header className="header-divider">Settings</header>
      <ProfileForm className="mb-8 max-w-[60rem]" />
      <div className="flex">
        <FvLinkButton
          theme="default"
          icon="power-off"
          href={`${authUri}/signout`}
        >
          Logout
        </FvLinkButton>
      </div>
    </main>
  )
}
